// eslint-disable-next-line import/no-extraneous-dependencies
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';
import getAllBogoSpecialsForCart from './get-all-bogo-specials-for-cart';
import determineRewards from './determine-rewards';
import { mergeSatisfiers } from './common';
// Determine possible BOGO discounts to be applied later. NOTE: bogoCalcsData will be mutated
var determineBogoDiscounts = function(param) {
    var bogoCalcsData = param.bogoCalcsData, items = param.detailsSorted, discountTaxOrder = param.discountTaxOrder, medicalOrder = param.medicalOrder, globalSpecialsSettings = param.globalSpecialsSettings;
    if (!bogoCalcsData.allBogoSpecials) {
        // Attach to bogoCalcsData for reruns
        bogoCalcsData.allBogoSpecials = getAllBogoSpecialsForCart(items, medicalOrder, globalSpecialsSettings);
    }
    var allBogoSpecials = bogoCalcsData.allBogoSpecials;
    if (allBogoSpecials.length > 0) {
        _.forEach(allBogoSpecials, function(bogoSpecial) {
            /*
        Here we want to group the items by their matching SKU if it is
        required by the offer (LLx). When the SKU is present we only want to qualify products that
        match in SKU, so below we separate the items into an array of arrays that are
        grouped by SKU
       */ var itemGroups = [
                items
            ];
            if (bogoSpecial === null || bogoSpecial === void 0 ? void 0 : bogoSpecial.requireSingleSKU) {
                itemGroups = _.values(_.reduce(items, function(skuGroups, item) {
                    if (!skuGroups[item.cannonicalSKU]) {
                        skuGroups[item.cannonicalSKU] = [];
                    }
                    skuGroups[item.cannonicalSKU].push(item);
                    return skuGroups;
                }, {}));
            }
            _.forEach(itemGroups, function(itemGroup) {
                determineRewards(bogoCalcsData, bogoSpecial, discountTaxOrder, itemGroup, globalSpecialsSettings);
            });
        });
        var applicableRewards = {};
        // here we need to merge classic rewards and discount to cart rewards
        var mergedRewards = mergeSatisfiers(bogoCalcsData.rewardsSatisfiers, bogoCalcsData.discountToCartRewards, true);
        _.forEach(mergedRewards, function(satisfier, itemKey) {
            applicableRewards[itemKey] = _.reduce(satisfier.rewards, function(rewards, current) {
                var _current_reward_discountToCart, _current_reward_discountToCart1, _bogoCalcsData_conditionsSatisfiers_itemKey, _bogoCalcsData_conditionsSatisfiers, _current_reward, _current_reward_discountToCart2, _current_reward1, _current_reward2, _current_reward3, _current_reward_discountToCart3, _current_reward_discountToCart4, _current_reward4;
                // SECPO = stacking enabled compounding percent off
                // DTC = discount to cart
                var isSecpoDtc = !!((_current_reward_discountToCart = current.reward.discountToCart) === null || _current_reward_discountToCart === void 0 ? void 0 : _current_reward_discountToCart.enabled) && current.discountStacking && ((_current_reward_discountToCart1 = current.reward.discountToCart) === null || _current_reward_discountToCart1 === void 0 ? void 0 : _current_reward_discountToCart1.discountType) === 'percentDiscount' && current.stackingBehavior === 'compounding';
                bogoCalcsData.containsStackingPercentageCompoundingDtc = bogoCalcsData.containsStackingPercentageCompoundingDtc || isSecpoDtc;
                rewards.push(_object_spread_props(_object_spread({
                    applicableQuantity: current.quantity,
                    conditionQuantity: _.reduce(((_bogoCalcsData_conditionsSatisfiers = bogoCalcsData.conditionsSatisfiers) === null || _bogoCalcsData_conditionsSatisfiers === void 0 ? void 0 : (_bogoCalcsData_conditionsSatisfiers_itemKey = _bogoCalcsData_conditionsSatisfiers[itemKey]) === null || _bogoCalcsData_conditionsSatisfiers_itemKey === void 0 ? void 0 : _bogoCalcsData_conditionsSatisfiers_itemKey.conditions) || [], function(quantity, condition) {
                        return condition.specialId === current.specialId ? quantity + condition.quantity : quantity;
                    }, 0),
                    isItemsForAPriceReward: !!((_current_reward = current.reward) === null || _current_reward === void 0 ? void 0 : _current_reward.isItemsForAPriceReward),
                    isDiscountToCartReward: !!((_current_reward_discountToCart2 = current.reward.discountToCart) === null || _current_reward_discountToCart2 === void 0 ? void 0 : _current_reward_discountToCart2.enabled)
                }, ((_current_reward1 = current.reward) === null || _current_reward1 === void 0 ? void 0 : _current_reward1.dollarDiscount) ? {
                    dollarDiscount: Big(current.reward.dollarDiscount).times(current.reward.redemptionMultiplier || 1).toString()
                } : {}, ((_current_reward2 = current.reward) === null || _current_reward2 === void 0 ? void 0 : _current_reward2.percentDiscount) ? {
                    percentDiscount: current.reward.percentDiscount
                } : {}, ((_current_reward3 = current.reward) === null || _current_reward3 === void 0 ? void 0 : _current_reward3.targetPrice) ? {
                    targetPrice: current.reward.targetPrice
                } : {}, isSecpoDtc ? {
                    redemptionMultiplier: current.reward.redemptionMultiplier
                } : {}), {
                    displayAsPercentDiscount: !!((_current_reward_discountToCart3 = current.reward.discountToCart) === null || _current_reward_discountToCart3 === void 0 ? void 0 : _current_reward_discountToCart3.enabled) && ((_current_reward_discountToCart4 = current.reward.discountToCart) === null || _current_reward_discountToCart4 === void 0 ? void 0 : _current_reward_discountToCart4.discountType) === 'percentDiscount',
                    isSecpoDtc: isSecpoDtc,
                    rewardId: (_current_reward4 = current.reward) === null || _current_reward4 === void 0 ? void 0 : _current_reward4._id,
                    satisfiedBy: current.satisfiedBy || {},
                    specialId: current.specialId,
                    specialType: 'bogo',
                    stackingMode: current.stackingMode,
                    discountStacking: current.discountStacking,
                    stackingBehavior: current.stackingBehavior,
                    nonStackingBehavior: current.nonStackingBehavior,
                    discountPrecedence: current.discountPrecedence,
                    settingsDerivedFrom: current.settingsDerivedFrom
                }));
                return rewards;
            }, []);
        });
        bogoCalcsData.applicableRewards = applicableRewards;
    }
    bogoCalcsData.redetermineDiscounts = false;
    return bogoCalcsData;
};
export default determineBogoDiscounts;
